// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type Rechnung } from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export type KorrekturRechnungZuweisenQuery = {
  korrekturBelegTyp?: string;
  rechnungId?: string;
};

export function useKorrekturRechnungZuweisen(): (
  korrekturRechnungId: string,
  query: KorrekturRechnungZuweisenQuery
) => Promise<Rechnung> {
  const getAPI = useGetApi();
  return useCallback(
    async (korrekturRechnungId, query = {}) =>
      (await getAPI()).rechnungen.korrekturRechnungZuweisen({
        korrekturRechnungId,
        ...query,
      }),
    [getAPI]
  );
}
